const UNITS: { limit: number; divisor: number; word: Intl.RelativeTimeFormatUnit }[] = [
  { limit: 60, divisor: 1, word: 'second' },
  { limit: 3600, divisor: 60, word: 'minute' },
  { limit: 86400, divisor: 3600, word: 'hour' },
  { limit: 604800, divisor: 86400, word: 'day' },
  { limit: 2629800, divisor: 604800, word: 'week' },
  { limit: 31557600, divisor: 2629800, word: 'month' },
  { limit: Infinity, divisor: 31557600, word: 'year' },
];

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export function formatRelativeTime(iso: string): string {
  const diffSec = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  const abs = Math.abs(diffSec);

  for (const { limit, divisor, word } of UNITS) {
    if (abs < limit) {
      const value = Math.round(diffSec / divisor);
      return rtf.format(value, word);
    }
  }

  return rtf.format(0, 'second');
}
